<template>
  <div class="w-full flex flex-col overflow-hidden">
    <loading v-if='$apollo.loading' />

    <div v-if='postTypeToCreate !== "post"' class="p-4" >
      <div class="w-full bg-gray-800 bg-no-repeat" style="
        background-blend-mode: multiply;
        background-position: center center;
        background-size: contain;
        background-image: url('/img/PBC_Ninja.svg');
      ">
        <div class="p-10 py-12 flex flex-col flex-wrap justify-center content-center">
          <div class="z-60 mt-4 auth-content-rotate">
              <h1 class="text-white font-bold text-2xl">Unleash</h1>
              <h1 class="text-white text-xl -mt-3">Your inner</h1>
              <h2 class="text-blue-300 font-bold text-2xl -mt-2">Memelord <span class="text-white font-normal">or</span> Game Ninja</h2>
          </div>
        </div>
      </div>
    </div>

    <create-post id="after-upload" v-if='gamedata.id'
      :type="postTypeToCreate"
      :draft-id='draftId'
      class="grow w-full"
      @done="done"
      :gamedata='gamedata'
      :parent-id='draft.parentId'
      :game-id='draftId'
      :op-id='draft.opId'
      :key='draftId' 
      :initial-title='draft.title'
      @change-draft='onChangeDraft'
      @change-stash='onChangeStash'
      />

    <pbc-error v-if='!!error' :error='error' :retry='true' @retry='onRetry' message='Could not load post' />

  </div>
</template>
<script>
import { formatISO9075, addMinutes } from 'date-fns'
import { cloneDeep } from 'lodash';
import { getPostDraftsQuery } from '@/gql/Queries.js';
import gql from 'graphql-tag';
import CreatePost from '@ui/organisms/CreatePost.vue';

export default {
  props:{
  },
  components: {
    CreatePost,
  },
  data() {
    const draftId = this.$route.params.draftId;
    return {
      draftId,
      error:'',
      gamedata:{},
      draft:{},
      postDrafts:[]
    }
  },
  apollo: {
    postDrafts: {
      query: getPostDraftsQuery,
      client: 'localClient',
      clientId: 'localClient',
      skip() {
        return !!this.postDrafts.length;
      },
      async result({data,loading,networkStatus}) {
        if (!data) {
          console.error('lol', data, loading, networkStatus);
          return;
        }
        console.log('huv data', data, loading, networkStatus);
        const draftId = this.draftId;
        let drafts = data.postDrafts;

        drafts = drafts.filter( ({id}) => {
          return id === draftId;
        });
        //this.useDraft = !!drafts.length;
        if (!!drafts.length) {
          const draft = drafts[0];
          console.log('edit draft', draft.title, draft);
          const editingGamedata = cloneDeep(JSON.parse(draft.gamedata));

          this.gamedata = editingGamedata;

          this.draft = draft;

        } else {
          console.error('could not find draft');
        }


      }
    }

  },
  mounted() {
    /*
    // I hate navbars so much
    const navbar = document.querySelector('#nav-bar');
    const bounds = navbar.getBoundingClientRect();
    console.log('bounds', bounds);
    this.$el.style.height = (window.innerHeight - bounds.height) + "px";
    this.$el.style['max-height'] = (window.innerHeight - bounds.height) + "px";
    */

    this.$store.commit('setCurrentActivityId', this.draftId);
  },
  methods:{
    onRetry() {
      this.$apollo.queries.postDrafts.refetch();
      this.error = '';
    },
    done({post}) {
      if (post.type === 'post' || this.editingParentId === 'root') {
        this.$router.push({
          name:'new',
          query:{
            posted:true,
            postedId:post.id
          },
          hash:'#p' + post.id
        });
        this.$store.commit('addPostedPostId', post.id);
      } else {
        this.$router.push({
          name:'play',
          params:Object.assign({}, this.$route.params, {
            id:this.editingParentId
          }),
          hash:'#editor',
          query:{
            feed:'posted'
          }
        });
      }

      this.$eventbus.emit("posted");
    },
    onChangeStash({parentId,opId,draftId}) {
      this.editingParentId = parentId;
      this.editingOpId = opId;
      this.draftId = draftId;
    },
    onChangeDraft({parentId, opId, id}) {
      this.editingParentId = parentId;
      this.editingOpId = opId;
      this.draftId = id;
    },
    formatDate(d) {
      return formatDistanceToNow(new Date(d));
    },
    getUTCDate() {
      const date = new Date();
      return addMinutes(date, date.getTimezoneOffset());
    },
  },
  computed:{
    postTypeToCreate() {
      return this.$route.params.type || 'post';
    },
    gameId() {
      return this.draftId;
    },
  },
  watch:{
    '$route.params.parentId'(nv) {
      this.editingParentId = nv;
    },
    'draftId': {
      handler() {
        this.$store.commit('setCurrentActivityId', this.draftId);
        this.$router.replace({
          params:{
            draftId:this.draftId
          }
        });
      },
      immediate: true
    },
  },
}
</script>
